import { GET_FEEDBACK, UPDATE_FEEDBACK} from "../types";
import axios from "../../axios";
import Swal from 'sweetalert2';
import { getErrorMessage } from "../../helpers/ErrorMessage";

export const getFeedback = () => async (dispatch) => {
    try {
        const res = await axios.get("feedback/all");
        if (res.data.code === 1) {
            dispatch({type: GET_FEEDBACK, payload: res.data.data});
        }
    } catch (err) {
        console.log("ERR :", err)
        // const errorMessage = err.response?.data?.message || 'An unexpected error occurred';
        if (err.response.status === 404 && err.response.status === 500) {
            Swal.fire({
                title: 'Error!',
                text: "Server Issue",
                icon: 'error',
            });
        } else{
            const errorMessage = getErrorMessage(err.response?.data);
            Swal.fire({
                title: 'Error!',
                text: errorMessage,
                icon: 'error',
            });
        }
    }
};


// export const updateFeedback = (formData, form) => async (dispatch) => {
//     try {
//         // const updatedFormData = { ...formData, id: formData._id };
        
//         const updatedFormData = {
//             id: formData.id,
//             ...(formData.status && { status: formData.status }),
//         };
//         console.log("updatedFormData :", updatedFormData);
//         const res = await axios.post("feedback/update", updatedFormData);
        
//         if (res.data.code === 1) {
//             dispatch({type: UPDATE_FEEDBACK, payload: res.data.data});
//             Swal.fire({
//                 title: 'Success!',
//                 text: res.data.message,
//                 icon: 'success',
//             });
//             form.resetFields();
//             return;
//         }
//     } catch (err) {
//         // dispatch(setAlert(err.message, 'danger'));
//          // Use the global error message function
//          const errorMessage = getErrorMessage(err.response?.data);
//         console.log("errorMessage :", err.response?.data);
//         if (err.response?.data===undefined) {
//             Swal.fire({
//                 title: 'Success!',
//                 text: "Updated Record!",
//                 icon: 'success',
//             });
//         }else{
//             Swal.fire({
//                 title: 'Error!',
//                 text: errorMessage,
//                 icon: 'error',
//             });
//         }
//     }
// };

export const updateFeedbackStatus = (id, status) => async (dispatch) => {
    try {
      // const updatedFormData = { ...formData, id: formData._id };
      // console.log("formdata updateCustomerStatus:", id, status);
  
      const res = await axios.post(
        "feedback/update",
        { id, status },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
  
      if (res.data.code === 1) {
        dispatch({ type: UPDATE_FEEDBACK, payload: res.data.data });
        Swal.fire({
          title: "Success!",
          text: res.data.message,
          icon: "success",
        });
      } else {
        Swal.fire({
          title: "Warning!",
          text: res.data.message,
          icon: "warning",
        });
      }
    } catch (err) {
       // Use the global error message function
       const errorMessage = getErrorMessage(err.response?.data);
  
       Swal.fire({
           title: 'Error!',
           text: errorMessage,
           icon: 'error',
       });
    }
  };





